import { EditOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import type { ModelProductBrand } from '@app/api/Products';
import type { GetColumnType } from '@app/pages/Warehouses/Brands/types';

import type { ColumnsType } from 'antd/es/table';

export const getBrandsColumns: GetColumnType = ({ onEdit, IsBrandEdit }) => {
  const columns: ColumnsType<ModelProductBrand> = [
    {
      title: 'Название',
      dataIndex: 'Name',
      key: 'Name',
      ellipsis: true,
      width: 220,
      render: (text) => (
        <span className="no-wrap-text" style={{ maxWidth: 300 }}>
          {text}
        </span>
      ),
    },
    {
      title: 'Товары',
      dataIndex: 'CountProducts',
      key: 'CountProducts',
      width: 120,
      render: (value) => value.toLocaleString('ru-RU'),
    },
    {
      title: 'Примечание',
      dataIndex: 'Comment',
      key: 'Comment',
      ellipsis: true,
      width: 200,
      render: (text) => (
        <span className="no-wrap-text" style={{ maxWidth: 300 }}>
          {text}
        </span>
      ),
    },

    {
      title: null,
      key: 'actions',
      width: 48,
      fixed: 'right',
      render: (_: unknown, row: ModelProductBrand) => (
        <>
          {IsBrandEdit && (
            <Button icon={<EditOutlined />} onClick={() => onEdit(row?.Id)} />
          )}
        </>
      ),
    },
  ];

  return columns;
};
